import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Toast } from "primereact";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";

import { useForm } from "../../../Hooks/useForm";
import Loader from "../../../Components/Loader/Loader";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { toastShow } from "../../../Services/ToastService";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Lang/BaseLang";
import { getLabel } from "../../../Services/Language/LanguageService";

import { EditarEstados, GuardarEstados } from "../../../../API/Global/Status/StatusRequests";

const EstadosCRUD = ({
  dialog,
  setDialog,
  selected,
  setSelected  = () => {},
  modo,
  getInfo = () => {},
}) => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  

  const initialValues = {
    IdStatus: -1,
    StatusName: "",
    StatusCategory: "",
    StatusDescription: "",
    Background: "#ffffff",
    Color: "#000000",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    setValues({
      IdStatus: selected ? selected?.IdStatus : -1,
      StatusName: selected?.StatusName || "",
      StatusCategory: selected?.StatusCategory || "",
      StatusDescription: selected?.StatusDescription || "",
      Background: selected?.Background || "#ffffff",
      Color: selected?.Color || "#000000",
    });

    setLoading(false);
  };

  const onHide = () => {
    setDialog(false);
    setSelected(null);
  };

  const verificarInfo = () => {
    let error = {};

    if (!values.StatusName) {
      error.StatusName = true;
      error.error = true;
    }

    if (!values.StatusCategory) {
      error.StatusCategory = true;
      error.error = true;
    }

    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();

    if (!values.Background) {
      toastShow(toast, "warn", "Datos requeridos", 'Color de fondo y color de letra son requeridos');
      return
    }

    if (!e.error) {

      const Datos = {
        IdStatus: values?.IdStatus,
        StatusName: values?.StatusName,
        StatusCategory: values?.StatusCategory,
        StatusDescription: values?.StatusDescription,
        Background: values?.Background,
        Color: values?.Color || '#000000'
      };

      setLoading(true);
      if (values?.IdStatus > 0) {
        const respuesta = await EditarEstados(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      } else {
        const respuesta = await GuardarEstados(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (dialog) {
      getValoresIniciales();
    }
  }, [dialog]);


  const dialogTitle = modo === "Crear" ? `Agregar Estado` : `Editar Estado`

  return (
    <div>
      <Dialog
        visible={dialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center mx-5">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                    <InputText
                      name="StatusName"
                      value={values.StatusName}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      className={error.StatusName ? "p-invalid" : ""}
                    />
                    <label htmlFor="StatusName">Estado</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="StatusCategory"
                    value={values.StatusCategory}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.StatusCategory ? "p-invalid" : ""}
                  />
                  <label htmlFor="StatusCategory">Categoría</label>
                </span>
              </div>    
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="StatusDescription"
                      value={values.StatusDescription}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      className={error.StatusDescription ? "p-invalid" : ""}
                    />
                    <label htmlFor="StatusDescription">Descripción</label>
                  </span>
              </div>

              <div className="field col-2 me-2">
                <label htmlFor="Background">Color de Fondo</label>
                <input
                  type="color"
                  name="Background"
                  value={values?.Background}
                  onChange={handleInputChange}
                  style={{ width: "75%", border: "none" }}
                />
              </div>

              <div className="field col-2 me-2">
                <label htmlFor="Color">Color de Letra</label>
                <input
                  type="color"
                  name="Color"
                  value={values?.Color}
                  onChange={handleInputChange}
                  style={{ width: "75%", border: "none" }}
                />
              </div>

              <div
                style={{
                  backgroundColor: values.Background,
                  color: values.Color,
                  padding: "10px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontWeight: "bold",
                  marginTop: "15px",
                  width:'25%',
                  fontSize:12
                }}
              >
                {values.StatusName}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default EstadosCRUD;
